import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';

@Component({
    selector: 'jhi-text-input',
    templateUrl: './text-input.component.html'
})
export class TextInputComponent implements OnInit {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        min: number | null;
    @Input()
        max: number | null;
    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Output()
        action = new EventEmitter<void>();
    @Input()
        enableChangeButton: boolean;

    textValue: string;

    constructor() {}

    ngOnInit(): void {
        if (this.min == null) {
            this.min = 0;
        }
        if (this.max == null) {
            this.max = Number.MAX_VALUE;
        }
        this.textValue = this.value;
    }

    onClick() {
        if (this.value && this.value !== '') {
            this.valueChange.emit(null);        
        }
        
        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.value = this.textValue;
        this.valueChange.emit(this.value);
        this.action.emit(null);
    }
}
